import React, {
  SetStateAction,
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { ConfigOptionsContext } from "../../../../../components/newPortal/NewPortalLayout";
import {
  getAllFeaturesForSelectedRole,
  setAppSubscription,
  setClientConfigRef,
} from "../../../../../services/uiConfigService";
import { useSelector } from "react-redux";
import store from "../../../../../stateManagement/store";
import Loader from "../../../../../components/loading/Loader";
import { ImageIdToSVGMap } from "../../../../../components/newPortal/UiConfigOptions";

export interface otherConfigOptionsAttributes {
  id: string;
  icon?: string;
  hasASelectedChild?:boolean;
  subfeatures?:otherConfigOptionsAttributesFeature[]
}
export interface uiSchema{
  question:string;
  description?:string|object;
  config:string;
  validations?:any;
  displayType?:string;
  dependsOn?:Record<string,any>,
  affectedValues:string[]

}
export interface Configurations{
  name:string,
  domainType:string,
  loaders:string[],
  uiSchema:uiSchema,
    section:string;
}

export interface otherConfigOptionsAttributesFeature {
  id: string;
  isSelected?: boolean;
  serviceId:string;
  route?:string;
  supportedAppTypes: string[];
  action?: "added" | "removed";
  featureConfigName?: string;
  additionalActivationConfigurations?: {
    domainType: string;
    domainValues: any[];
  }[];
  addTemplate?: boolean;
  domainMapping:Record<string,string[]>;
  appType?: string;
  configuration:Configurations[]
}


const ConfigBottomBar: React.FC<{
  style?: React.CSSProperties;
  className?: string;
  handleStepIconClick?: (stepNumber: number) => void;
  displayMandatory: boolean;
  setFeatureList?:React.Dispatch<SetStateAction<otherConfigOptionsAttributesFeature[]>>
  setSubFeature?:React.Dispatch<SetStateAction<otherConfigOptionsAttributesFeature>>
}> = ({ style, className, handleStepIconClick, displayMandatory }) => {
  const context = useContext(ConfigOptionsContext);
  const [hasActiveChild, setHasActiveChild] = useState(false);
  const [activeChild, setActiveChild] = useState<string | undefined>(undefined);
  useEffect(() => {
    setHasActiveChild(!!localStorage.getItem("activeChild"));
  }, []);

  const { optional, setOptional, uiConfigOptionsProp, setUiConfigOptionsProp,changeBottomBar} =
    context!;
  

  function handleIconClick(iconId: string): void {
    setOptional(iconId);
    setActiveChild(iconId);

    if (handleStepIconClick) {
      handleStepIconClick(3);
    }
  }

  const savedRole: any = useSelector(() => store.getState().roleState.role);
  const savedAppType: any = useSelector(
    () => store.getState().appTypeState.appType
  );
  const clientConfigRef = useRef<any[]>([]);
  const firstUpdate = useRef(true);
  const [isLoader, setIsloader] = useState<boolean>(false);
  const [standard, setStandard] = useState<string | undefined>(undefined);
  const [allFeaturesForSelectedRole, setAllFeaturesForSelectedRole] = useState<otherConfigOptionsAttributes[]>([]);

  const init = async () => {
    await setClientConfigRef(clientConfigRef,setIsloader);
    setAppSubscription(setStandard,clientConfigRef.current);
    updateSelectedAndDevelopedFeatures();
  }
  
  useEffect(() => {
    init();
  }, []);
  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
  });

  const updateSelectedAndDevelopedFeatures = () => {
    if(clientConfigRef.current.length < 1  || !savedRole || !savedAppType){
      return;
    }
    const allFeatures = uiConfigOptionsProp.filter((opt)=>opt.hasASelectedChild)
    setAllFeaturesForSelectedRole(allFeatures);
    // if >1 activechild or 0 active chile , only set firstChild as active if not set
    if(allFeatures.length > 0 ){
      setOptional(allFeatures[0].id);
    }
  }
// console.log(changeBottomBar)
  useEffect(() => {
    updateSelectedAndDevelopedFeatures();
  }, [changeBottomBar]);

  return isLoader ? (
    <Loader />
  ) : (
    
    <div className="config-options" style={style}>
      {allFeaturesForSelectedRole
        .map((option,index) => {
          return (
            <div
              className={`${className ?? "config_option_container_temp"} ${
                (optional === option.id)  ? "active" : ""
              }`}
              key={option.id}
              onClick={() =>{
                // debugger;
                handleIconClick(option.id)}}
              aria-label={`Select ${option.id}`}
            >
              <img
                src={ImageIdToSVGMap[option.icon ?? "default"]}
                alt={`${option.id} icon`}
              />
              <span>{ option.id}</span>
            </div>
          );
        })}
    </div>
  );
};

export default ConfigBottomBar;

